import React from 'react';


const OnBoardingProgressBar = ({ progress = 0 }) => {
  return (
    <div className="h-[3px] bg-[#e4e5e7] w-full">
      <div
        className="h-full bg-[#ff5323] transition-all duration-500 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export default OnBoardingProgressBar;